<footer class="relative bg-[#2b3890] overflow-hidden py-[1.2rem] mt-[6rem]">

  <!-- Decorative lines background image (reused from header) -->
  <div class="clip-bg-lines"></div>

  <!-- Inner layout -->
  <div class="relative max-w-[160rem] mx-auto px-[2rem] sm:px-[3.2rem] flex flex-wrap items-center justify-center sm:justify-start gap-x-[2.4rem] gap-y-[1rem]">

    <!-- Logo -->
    <a routerLink="/" class="shrink-0 no-underline">
      <img src="/images/app title.svg" alt="Arch of Traits" class="h-[4.5rem]" />
    </a>

    <!-- Vertical divider (hidden on small screens) -->
    <div class="hidden sm:block w-px h-[4rem] bg-white/30 shrink-0"></div>

    <!-- Redeem button -->
    @if (!hideActions) {
    <button
      routerLink="/redeem"
      class="bg-[rgba(0,193,243,1)] text-white rounded-full px-[2.4rem] py-[1rem] text-[1.2rem] font-bold tracking-[0.08em] whitespace-nowrap cursor-pointer border-none transition-opacity duration-200 hover:opacity-85 shrink-0"
    >
      REDEEM ASSESSMENT
    </button>
    }

    <!-- Contact info -->
    @if (phone || email) {
    <p class="text-white text-[1.4rem] font-medium whitespace-nowrap m-0">
      @if (phone) {<span>{{ phone }}</span>}
      @if (phone && email) { <span> | </span> }
      @if (email) {<a [href]="'mailto:' + email" class="text-white no-underline cursor-pointer hover:underline">{{ email }}</a>}
    </p>
    }

    <!-- Copyright -->
    <p class="text-white text-[1.2rem] font-semibold tracking-[0.06em] whitespace-nowrap m-0 sm:ml-auto">
      &copy;{{ copyrightYear }} ARCH OF TRAITS
    </p>

  </div>
</footer>
